import { render } from "./survey-modal.vue?vue&type=template&id=4b30ab26&lang=pug"
import script from "./survey-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./survey-modal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__